var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModulram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1249 36.0778L31.7145 48.7935L0.87793 31.2946L23.2861 18.5811L54.1249 36.0778Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7145 48.7937L31.714 54.125L0.875 36.6272V31.2961L0.877832 31.2947L31.7145 48.7937Z",
    fill: "#C6C6C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16895 32.7642V36.6244L2.80048 36.2668L26.2069 49.5467V46.4031L2.16895 32.7642ZM23.8059 47.7198L5.42969 37.297L5.86994 35.2832L24.2641 45.7169L23.8059 47.7198Z",
    fill: "#575756"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1246 36.0779L54.1249 41.4087L31.7139 54.125L31.7143 48.7936L54.1246 36.0779Z",
    fill: "#6F6F6E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4201 48.7936V52.6543L27.5059 51.0007V47.1401L30.4201 48.7936Z",
    fill: "#6F6F6E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2069 49.5467V50.2634L2.16895 36.6245L2.80048 36.2668L26.2069 49.5467Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16895 32.7642L3.42465 33.4768L2.80048 36.2668L2.16895 36.6244V32.7642Z",
    fill: "#6F6F6E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42495 33.4768L4.68066 34.1894L4.05649 36.9794L2.80078 36.2668L3.42495 33.4768Z",
    fill: "#B1B1B1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5753 46.0439L26.2069 46.403V49.5466L24.9512 48.8339L25.5753 46.0439Z",
    fill: "#B1B1B1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.2641 45.7169L5.86994 35.2832L5.42969 37.297L23.8059 47.7199L24.2641 45.7169Z",
    fill: "#575756"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.43838 36.4558C1.48187 36.3233 1.44404 36.1927 1.3539 36.1641C1.26376 36.1355 1.15544 36.2198 1.11195 36.3523C1.06846 36.4849 1.10628 36.6154 1.19642 36.644C1.28656 36.6726 1.39489 36.5883 1.43838 36.4558Z",
    fill: "#575756"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40011 37.3223L1.37 36.1704L1.19629 36.6439L3.18608 37.776L3.40011 37.3223Z",
    fill: "#575756"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46376 37.6067C3.50725 37.4741 3.46943 37.3435 3.37929 37.315C3.28915 37.2864 3.18083 37.3707 3.13734 37.5032C3.09385 37.6357 3.13167 37.7663 3.22181 37.7949C3.31195 37.8235 3.42027 37.7392 3.46376 37.6067Z",
    fill: "#3C3C3B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05619 36.9795L3.42227 37.3345L2.16895 36.6245L2.80048 36.2668L4.05619 36.9795Z",
    fill: "#C6C6C5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3593 49.4614C24.4028 49.3289 24.3649 49.1983 24.2748 49.1697C24.1847 49.1411 24.0763 49.2254 24.0328 49.3579C23.9894 49.4905 24.0272 49.6211 24.1173 49.6496C24.2075 49.6782 24.3158 49.5939 24.3593 49.4614Z",
    fill: "#575756"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.321 50.3279L24.2909 49.176L24.1172 49.6495L26.107 50.7816L26.321 50.3279Z",
    fill: "#575756"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3847 50.612C26.4282 50.4795 26.3903 50.3489 26.3002 50.3203C26.2101 50.2918 26.1017 50.3761 26.0582 50.5086C26.0147 50.6411 26.0526 50.7717 26.1427 50.8003C26.2328 50.8288 26.3412 50.7446 26.3847 50.612Z",
    fill: "#3C3C3B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2076 49.5466L25.5736 49.9017L24.3203 49.1916L24.9518 48.834L26.2076 49.5466Z",
    fill: "#C6C6C5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1249 30.747L31.7145 43.4627L0.87793 25.9638L23.2861 13.2502L54.1249 30.747Z",
    fill: "#D9D9D9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7145 43.4628L31.714 48.7942L0.875 31.2964V25.9653L0.877832 25.9639L31.7145 43.4628Z",
    fill: "#C6C6C5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16895 27.4333V31.2936L2.80048 30.936L26.2069 44.2159V41.0723L2.16895 27.4333ZM23.8059 42.389L5.42971 31.9661L5.86996 29.9524L24.2641 40.3861L23.8059 42.389Z",
    fill: "#575756"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1246 30.7471L54.1249 36.0779L31.7139 48.7942L31.7143 43.4628L54.1246 30.7471Z",
    fill: "#6F6F6E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4201 43.4628V47.3234L27.5059 45.6699V41.8093L30.4201 43.4628Z",
    fill: "#6F6F6E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2069 44.2159V44.9326L2.16895 31.2937L2.80048 30.936L26.2069 44.2159Z",
    fill: "#D9D9D9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16895 27.4333L3.42465 28.146L2.80048 30.936L2.16895 31.2936V27.4333Z",
    fill: "#6F6F6E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42495 28.146L4.68066 28.8586L4.05649 31.6486L2.80078 30.936L3.42495 28.146Z",
    fill: "#B1B1B1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5753 40.7134L26.2069 41.0724V44.216L24.9512 43.5034L25.5753 40.7134Z",
    fill: "#B1B1B1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.2641 40.3861L5.86994 29.9524L5.42969 31.9662L23.8059 42.3891L24.2641 40.3861Z",
    fill: "#575756"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1.43837 31.125C1.48186 30.9924 1.44405 30.8619 1.35391 30.8333C1.26377 30.8047 1.15544 30.889 1.11195 31.0215C1.06846 31.154 1.10628 31.2846 1.19642 31.3132C1.28656 31.3418 1.39489 31.2575 1.43837 31.125Z",
    fill: "#575756"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40011 31.9915L1.37 30.8396L1.19629 31.3131L3.18608 32.4452L3.40011 31.9915Z",
    fill: "#575756"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46377 32.2759C3.50726 32.1433 3.46944 32.0127 3.3793 31.9842C3.28916 31.9556 3.18083 32.0399 3.13734 32.1724C3.09385 32.3049 3.13167 32.4355 3.22181 32.4641C3.31195 32.4927 3.42028 32.4084 3.46377 32.2759Z",
    fill: "#3C3C3B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05619 31.6487L3.42227 32.0037L2.16895 31.2937L2.80048 30.936L4.05619 31.6487Z",
    fill: "#C6C6C5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3593 44.1306C24.4028 43.9981 24.3649 43.8675 24.2748 43.8389C24.1847 43.8103 24.0763 43.8946 24.0328 44.0271C23.9894 44.1597 24.0272 44.2903 24.1173 44.3188C24.2075 44.3474 24.3158 44.2631 24.3593 44.1306Z",
    fill: "#575756"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M26.321 44.9971L24.2909 43.8452L24.1172 44.3187L26.107 45.4508L26.321 44.9971Z",
    fill: "#575756"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3847 45.2812C26.4282 45.1487 26.3903 45.0181 26.3002 44.9895C26.2101 44.961 26.1017 45.0452 26.0582 45.1778C26.0147 45.3103 26.0526 45.4409 26.1427 45.4695C26.2328 45.498 26.3412 45.4138 26.3847 45.2812Z",
    fill: "#3C3C3B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2076 44.2158L25.5736 44.5709L24.3203 43.8608L24.9518 43.5032L26.2076 44.2158Z",
    fill: "#C6C6C5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1249 25.4162L31.7145 38.1319L0.87793 20.633L23.2861 7.91943L54.1249 25.4162Z",
    fill: "#D9D9D9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7145 38.132L31.714 43.4634L0.875 25.9656V20.6344L0.877832 20.6331L31.7145 38.132Z",
    fill: "#C6C6C5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16895 22.1025V25.9628L2.80048 25.6052L26.2069 38.8851V35.7415L2.16895 22.1025ZM23.8059 37.0582L5.42971 26.6353L5.86996 24.6215L24.2641 35.0553L23.8059 37.0582Z",
    fill: "#575756"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1246 25.4163L54.1249 30.7471L31.7139 43.4634L31.7143 38.132L54.1246 25.4163Z",
    fill: "#6F6F6E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4201 38.132V41.9926L27.5059 40.3391V36.4785L30.4201 38.132Z",
    fill: "#6F6F6E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2069 38.8851V39.6018L2.16895 25.9628L2.80048 25.6052L26.2069 38.8851Z",
    fill: "#D9D9D9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16895 22.1025L3.42465 22.8152L2.80048 25.6052L2.16895 25.9628V22.1025Z",
    fill: "#6F6F6E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42495 22.8152L4.68066 23.5278L4.05649 26.3178L2.80078 25.6052L3.42495 22.8152Z",
    fill: "#B1B1B1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5753 35.3826L26.2069 35.7416V38.8852L24.9512 38.1725L25.5753 35.3826Z",
    fill: "#B1B1B1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.2641 35.0553L5.86994 24.6216L5.42969 26.6354L23.8059 37.0582L24.2641 35.0553Z",
    fill: "#575756"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1.43838 25.7942C1.48187 25.6616 1.44405 25.531 1.35391 25.5025C1.26377 25.4739 1.15544 25.5582 1.11195 25.6907C1.06846 25.8232 1.10628 25.9538 1.19642 25.9824C1.28656 26.011 1.39489 25.9267 1.43838 25.7942Z",
    fill: "#575756"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40011 26.6607L1.37 25.5088L1.19629 25.9823L3.18608 27.1144L3.40011 26.6607Z",
    fill: "#575756"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46376 26.945C3.50725 26.8125 3.46944 26.6819 3.3793 26.6534C3.28916 26.6248 3.18083 26.7091 3.13734 26.8416C3.09385 26.9741 3.13167 27.1047 3.22181 27.1333C3.31195 27.1618 3.42028 27.0776 3.46376 26.945Z",
    fill: "#3C3C3B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05619 26.3179L3.42227 26.6729L2.16895 25.9628L2.80048 25.6052L4.05619 26.3179Z",
    fill: "#C6C6C5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3593 38.7998C24.4028 38.6673 24.3649 38.5367 24.2748 38.5081C24.1847 38.4795 24.0763 38.5638 24.0328 38.6963C23.9894 38.8288 24.0272 38.9594 24.1173 38.988C24.2075 39.0166 24.3158 38.9323 24.3593 38.7998Z",
    fill: "#575756"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M26.321 39.6663L24.2909 38.5144L24.1172 38.9879L26.107 40.12L26.321 39.6663Z",
    fill: "#575756"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3847 39.9504C26.4282 39.8179 26.3903 39.6873 26.3002 39.6587C26.2101 39.6302 26.1017 39.7144 26.0582 39.847C26.0147 39.9795 26.0526 40.1101 26.1427 40.1386C26.2328 40.1672 26.3412 40.0829 26.3847 39.9504Z",
    fill: "#3C3C3B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2076 38.885L25.5736 39.2401L24.3203 38.53L24.9518 38.1724L26.2076 38.885Z",
    fill: "#C6C6C5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1249 20.0856L31.7145 32.8014L0.87793 15.3024L23.2861 2.58887L54.1249 20.0856Z",
    fill: "#D9D9D9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7145 32.8012L31.714 38.1326L0.875 20.6348V15.3036L0.877832 15.3022L31.7145 32.8012Z",
    fill: "#C6C6C5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16895 16.7717V20.632L2.80048 20.2744L26.2069 33.5543V30.4107L2.16895 16.7717ZM23.8059 31.7274L5.42971 21.3045L5.86996 19.2907L24.2641 29.7245L23.8059 31.7274Z",
    fill: "#575756"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1246 20.0854L54.1249 25.4162L31.7139 38.1326L31.7143 32.8012L54.1246 20.0854Z",
    fill: "#6F6F6E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4201 32.8012V36.6618L27.5059 35.0083V31.1477L30.4201 32.8012Z",
    fill: "#6F6F6E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2069 33.5543V34.271L2.16895 20.632L2.80048 20.2744L26.2069 33.5543Z",
    fill: "#D9D9D9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16895 16.7717L3.42465 17.4844L2.80048 20.2744L2.16895 20.632V16.7717Z",
    fill: "#6F6F6E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42495 17.4844L4.68066 18.197L4.05649 20.987L2.80078 20.2744L3.42495 17.4844Z",
    fill: "#B1B1B1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5753 30.0518L26.2069 30.4108V33.5544L24.9512 32.8417L25.5753 30.0518Z",
    fill: "#B1B1B1"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.2641 29.7245L5.86994 19.2908L5.42969 21.3046L23.8059 31.7274L24.2641 29.7245Z",
    fill: "#575756"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1.43838 20.4634C1.48187 20.3308 1.44405 20.2002 1.35391 20.1717C1.26377 20.1431 1.15544 20.2274 1.11195 20.3599C1.06846 20.4924 1.10628 20.623 1.19642 20.6516C1.28656 20.6802 1.39489 20.5959 1.43838 20.4634Z",
    fill: "#575756"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40011 21.3301L1.37 20.1782L1.19629 20.6517L3.18608 21.7838L3.40011 21.3301Z",
    fill: "#575756"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46377 21.6142C3.50726 21.4817 3.46944 21.3511 3.3793 21.3225C3.28916 21.294 3.18083 21.3782 3.13734 21.5108C3.09385 21.6433 3.13167 21.7739 3.22181 21.8025C3.31195 21.831 3.42028 21.7468 3.46377 21.6142Z",
    fill: "#3C3C3B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05619 20.9871L3.42227 21.3421L2.16895 20.632L2.80048 20.2744L4.05619 20.9871Z",
    fill: "#C6C6C5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3593 33.469C24.4028 33.3364 24.3649 33.2059 24.2748 33.1773C24.1847 33.1487 24.0763 33.233 24.0328 33.3655C23.9894 33.498 24.0272 33.6286 24.1173 33.6572C24.2075 33.6858 24.3158 33.6015 24.3593 33.469Z",
    fill: "#575756"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M26.321 34.3355L24.2909 33.1836L24.1172 33.6571L26.107 34.7892L26.321 34.3355Z",
    fill: "#575756"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3847 34.6198C26.4282 34.4873 26.3903 34.3567 26.3002 34.3282C26.2101 34.2996 26.1017 34.3839 26.0582 34.5164C26.0147 34.6489 26.0526 34.7795 26.1427 34.8081C26.2328 34.8366 26.3412 34.7524 26.3847 34.6198Z",
    fill: "#3C3C3B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2076 33.5542L25.5736 33.9093L24.3203 33.1992L24.9518 32.8416L26.2076 33.5542Z",
    fill: "#C6C6C5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1249 18.3718L31.7145 31.0875L0.87793 13.5885L23.2861 0.875L54.1249 18.3718Z",
    fill: "#D9D9D9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7145 31.0876L31.714 32.8019L0.875 15.3041V13.59L0.877832 13.5886L31.7145 31.0876Z",
    fill: "#C6C6C5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1246 18.3718L54.1249 20.0856L31.7139 32.8019L31.7143 31.0876L54.1246 18.3718Z",
    fill: "#6F6F6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModulram);
export default __webpack_public_path__ + "static/media/modulram.ae219a84e21b404259aebea0b84d41b8.svg";
export { ForwardRef as ReactComponent };